// extracted by mini-css-extract-plugin
export default {"calendar_wrapper":"Bu","modify_order":"Cu","modify_order_header":"Eu","product_details_form_wrapper":"Fu","c_wrapper":"Gu","save_button":"Hu","title":"Iu","modify_order_title_wrapper":"Ju","note":"Ku","buttons_wrapper":"Lu"};
    if(module.hot) {
      // 1726593103434
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  